import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { Observable, of, Subscription } from 'rxjs';
import { DrawerServiceService } from 'src/app/Services/drawer-service.service';
import { MatSidenavModule } from '@angular/material/sidenav';
import { CommonModule } from '@angular/common';
import { BackgroundOverlayDrawerComponent } from '../background-overlay-drawer/background-overlay-drawer.component';
import { MaterialModule } from 'src/app/Shared/MaterialModule/material/material.module';
import { TranslateModule } from '@ngx-translate/core';


@Component({
  selector: 'app-main-drawer',
  standalone: true,
  imports: [MatSidenavModule,CommonModule,BackgroundOverlayDrawerComponent, MaterialModule, TranslateModule],
  templateUrl: './main-drawer.component.html',
  styleUrl: './main-drawer.component.scss'
})
export class MainDrawerComponent implements OnInit {
  
  drawer1$ : Observable<boolean>;
  drawerLayout$ : Observable<boolean> ;

  isDrawerOpened: Observable<boolean> = of(false);
  getComponent$: Subscription = new Subscription;
  drawerComponent = null;
  drawerWidthClass = '';
  
  @ViewChild('wmDynamicViewRef', { read: ViewContainerRef, static: true }) wmDynamicViewRef: any;

  constructor(
    private Drawerservice: DrawerServiceService
  ) {

    this.drawer1$ = this.Drawerservice.drawer1$;
    this.drawerLayout$ = this.Drawerservice.drawer1$;

   }

  ngOnInit() {
    this.isDrawerOpened = this.Drawerservice.isDrawerOpened;
    this.getComponent$ = this.Drawerservice.DrawerComponent.subscribe((component) => {
      this.drawerComponent = component;
      this.drawerWidthClass = component.widthClass;
      this.Drawerservice.loadComponent(this.wmDynamicViewRef, this.drawerComponent);
    });



  }

}
